<section class="dynamic-collapse">
    <div class="exit-plan-review" (click)="goto()">
        <div class="exit-text">Exit Plan Review</div>
        <!-- <img class="x" src="../../assets/img/close-btn2.svg" alt=""> -->
        <div class="svg-container">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="20" fill="white" />
                <circle cx="20" cy="20" r="20" class="svg-background" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12.9288 27.3211C13.4149 27.8072 14.2104 27.8072 14.6965 27.3211L27.0709 14.9467C27.557 14.4606 27.557 13.6651 27.0709 13.1789C26.5848 12.6928 25.7893 12.6928 25.3031 13.1789L12.9288 25.5533C12.4426 26.0394 12.4426 26.8349 12.9288 27.3211Z"
                    class="svg-sign" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12.9291 13.1789C12.4429 13.6651 12.4429 14.4606 12.9291 14.9467L25.3034 27.3211C25.7896 27.8072 26.5851 27.8072 27.0712 27.3211C27.5573 26.8349 27.5573 26.0394 27.0712 25.5533L14.6968 13.1789C14.2107 12.6928 13.4152 12.6928 12.9291 13.1789Z"
                    class="svg-sign" />
            </svg>
        </div>
        

    </div>
    <div *ngFor="let section of categorySections; let i = index">
        <ng-container *ngIf="section.content">
            <app-section-box [section]="section.content" [planCategory]="planCategory"
                (deleteItem)="showAnswerDelete($event)"></app-section-box>
        </ng-container>
    </div>
</section>

<app-scroll-top></app-scroll-top>